import React from "react"
import css from "./index.module.css"

export default function Header({ children }) {
  return <div className={css.header}>{children}</div>
}
